import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DatepickerModule } from '@spotsoftware/angular-components';
import { AgGridFilterDatepickerComponent } from './ag-grid-filter-datepicker.component';

@NgModule({
  declarations: [AgGridFilterDatepickerComponent],
  imports: [
    CommonModule,
    FormsModule,
    DatepickerModule
  ],
  exports: [AgGridFilterDatepickerComponent],
})
export class AgGridFilterDatepickerModule { }
